import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { base44 } from '@/api/base44Client';

export default function VerificationBlocked() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-6">
      <div className="max-w-md text-center">
        <ShieldAlert className="w-12 h-12 text-red-600 mx-auto mb-4" />
        <h1 className="text-xl font-bold text-black mb-3">Account blocked</h1>
        <p className="text-black mb-6">
          Your account could not be verified, so it has been blocked from making any further
          attempts. Please contact us directly to resolve this.
        </p>
        <Link to="/ContactUs" className="inline-flex items-center justify-center rounded-xl bg-brand-navy-deep text-white font-semibold px-6 py-3 w-full mb-3">
          Contact us
        </Link>
        <button onClick={() => base44.auth.logout('/')} className="text-sm text-brand-gray underline bg-transparent border-0">
          Sign out
        </button>
      </div>
    </div>
  );
}